export function any(input: unknown) {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return input as any
}
